"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePropTypes = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var honeycomb_1 = require("../../honeycomb");
var Image = function (image) {
    if (image.pictogram) {
        return React.createElement(honeycomb_1.Pictogram, { name: image.pictogram, alt: image.alt });
    }
    if (image.imageSrc) {
        return React.createElement("img", { src: image.imageSrc, alt: image.alt });
    }
    return null;
};
exports.ImagePropTypes = {
    alt: PropTypes.string.isRequired,
    imageSrc: function (props, propName, componentName) {
        if (props.imageSrc && props.pictogram) {
            return new Error("`" + propName + "` supplied to " + componentName + " with `pictogram`");
        }
        if (!props.imageSrc && !props.pictogram) {
            return new Error("received `" + props.imageSrc + "` for required prop `" + propName + "` in " + componentName);
        }
    },
    pictogram: function (props, propName, componentName) {
        if (props.imageSrc && props.pictogram) {
            return new Error("`" + propName + "` supplied to " + componentName + " with `imageSrc`");
        }
        if (!props.imageSrc && !props.pictogram) {
            return new Error("received `" + props.pictogram + "` for required prop `" + propName + "` in " + componentName);
        }
    },
};
Image.propTypes = exports.ImagePropTypes;
Image.displayName = 'Image';
exports.default = Image;
